/** The gold MemeGenes verification check — a faceted seal with a checkmark. */
export function GeneCheckIcon({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true" className="shrink-0">
      <path
        d="M10 1.5l2.2 1.6 2.7-.1 1 2.5 2.3 1.4-.8 2.6.8 2.6-2.3 1.4-1 2.5-2.7-.1L10 18.5l-2.2-1.6-2.7.1-1-2.5L1.8 13l.8-2.6L1.8 7.8l2.3-1.4 1-2.5 2.7.1L10 1.5z"
        fill="#D4A015"
      />
      <path d="M6.5 10l2.3 2.3 4.7-4.8" stroke="#111111" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
